import { useEffect, useState } from 'react';
import { Typography, Paper, styled, ToggleButtonGroup, Box } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import theme from 'theme';
import { useAuth } from '../../../auth';
import VacationTileCurrent from './VacationTileCurrent';
import VacationTilePrevious from './VacationTilePrevious';

const tileStates = {
  PREVIOUS: 'Old',
  CURRENT: 'Current',
  NEXT: 'Next',
};

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  '& .MuiToggleButtonGroup-grouped': {
    '&.Mui-selected': {
      background: '#EEEEEE',
      color: '#000000',
    },
  },
  '& .MuiToggleButtonGroup-groupedHorizontal:not(:first-child)': {
    marginLeft: 0,
  },
}));

const VacationTile = () => {
  const { user } = useAuth();

  const defaultTileState =
    (user.oldVacationDays ?? 0) > 0 ? tileStates.PREVIOUS : tileStates.CURRENT;
  const [tileState, setTileState] = useState();

  useEffect(() => {
    setTileState(defaultTileState);
  }, [defaultTileState]);

  const handleTileState = (_event, newState) => {
    if (newState !== null) {
      setTileState(newState);
    }
  };

  return (
    <Paper
      sx={{
        padding: '1.75rem 1.5rem 0.875rem 1.5rem',
        borderRadius: '0.25rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '1.063rem',
          marginBottom: '1.063rem',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          sx={{ color: '#000000', fontSize: '1.125rem', fontWeight: 500 }}
          variant="body1"
          component="div"
        >
          Vacation
        </Typography>
        <StyledToggleButtonGroup
          value={tileState}
          exclusive
          onChange={handleTileState}
          aria-label="text alignment"
        >
          <ToggleButton
            value={tileStates.PREVIOUS}
            sx={{
              fontSize: '0.875rem',
              color: '#000000',
              height: '2rem',
              textTransform: 'capitalize',
              fontWeight: 500,
            }}
            data-cy="previousVacationTab"
          >
            {user.availableDays < 0 ? tileStates.CURRENT : tileStates.PREVIOUS}
          </ToggleButton>
          <ToggleButton
            value={tileStates.CURRENT}
            sx={{
              fontSize: '0.875rem',
              color: '#000000',
              height: '2rem',
              textTransform: 'capitalize',
              fontWeight: 500,
            }}
            data-cy="currentVacationTab"
          >
            {user.availableDays < 0 ? tileStates.NEXT : tileStates.CURRENT}
          </ToggleButton>
        </StyledToggleButtonGroup>
      </Box>
      <Box sx={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
        {tileState === tileStates.CURRENT ? (
          <VacationTileCurrent user={user} />
        ) : (
          <VacationTilePrevious user={user} />
        )}
      </Box>
    </Paper>
  );
};

export default VacationTile;
